import React, { FC } from 'react'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'
import LangInfo from '../../../components/setting/LangInfo'

const Index: FC = () => {
  const { t } = useTranslation()

  return (
    <section className="setting_page">
      <Helmet>
        <title>{`Qasee - 設定 - 共通設定 - ${t("setting.language.caption")}`}</title>
      </Helmet>
      <section className="breadcrumb">
        設定
        &nbsp;&gt;&nbsp;
        共通設定
        &nbsp;&gt;&nbsp;
        {t("setting.language.caption")}
        &nbsp;
      </section>
      <section className="page_header">
        <h1>
          {t("setting.language.caption")}
        </h1>
      </section>
      <section className="page_description">
        <p>
          Qaseeの配信メール・通知で使用する言語を設定します。
        </p>
        <p>
          配信メール・通知で使用する言語の変更は、会社全体に反映されます。
        </p>
      </section>
      <section className="page_contents content-area">
        <div className="content-block">
          <div className="block-detail">
            <LangInfo />
          </div>
        </div>
      </section>
    </section>
  )
}

export default Index
